<template>
    <div class="complaint--comments">
        <div class="complaint--form-title">Reklamációhoz kapcsolódó kommentek</div>
        <div class="complaint--form-datas">
            <ul class="comments" ref="commentsList" v-if="comments.length">
                <li v-for="comment in comments" :key="comment.id">
                    <div>
                        <div class="comment--author">{{ comment.user.name }} - <small>{{ comment.created_at }}</small></div>
                        <div class="comment--text" v-if="!isEditing(comment.id)">{{ comment.comment }}</div>
                        <textarea v-else v-model="editedComment" />
                    </div>
                    <div class="comment--buttons">
                        <button class="comment--button" v-if="comment.isOwn" @click="editComment(comment)">Szerkesztés</button>
                        <button class="comment--button" v-if="isEditing(comment.id)" @click="updateComment(comment)">Mentés</button>
                        <button class="comment--button" v-if="comment.isOwn" @click="deleteComment(comment.id)">Törlés</button>
                    </div>
                </li>
            </ul>

            <span class="comments--empty" v-else>
                Nincsenek még kommentek
            </span>

            <div class="comment--add-form">
                <textarea v-model="newComment" placeholder="Komment írása..."></textarea>
                <button class="complaint--submit" @click="addComment">Küldés</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import config from '../plugins/config.js';

export default {
    name: "ComplaintComments",
    props: {
        complaint: {
            required: true
        }
    },
    data() {
        return {
            comments: [],
            newComment: '',
            editedComment: '',
            editingCommentId: null,
        };
    },
    mounted() {
        this.fetchComments();
    },
    methods: {
        fetchComments() {
            axios.get(`complaints/${this.complaint}/comments`, config.AXIOS_DEFAULTS)
                .then(response => {
                    this.comments = response;
                    this.scrollToBottom();
                }).catch(error => {
                    console.error("Error fetching comments:", error);
                });
        },

        addComment() {
            if (!this.newComment.trim()) return;
            axios.post(`complaints/${this.complaint}/comments`, { comment: this.newComment.trim() }, config.AXIOS_DEFAULTS)
                .then((response) => {
                    this.fetchComments();
                    this.newComment = '';
                    this.$store.commit('setNotification', [response.message]);
                    this.scrollToBottom();
                    this.$emit('updated', true)
                })
                .catch(error => {
                    console.error("Error adding comment:", error);
                });
        },

        editComment(comment) {
            this.editedComment = comment.comment;
            this.editingCommentId = comment.id;
        },

        updateComment(comment) {
            axios.put(`complaints/${this.complaint}/comments/${comment.id}`, {
                comment: this.editedComment,
            },  config.AXIOS_DEFAULTS).then((response) => {
                this.$store.commit('setNotification', [response.message]);
                this.fetchComments();
                this.editingCommentId = null;
                this.editedComment = '';
                this.$emit('updated', true)
            }).catch(error => {
                console.error("Error updating comment:", error);
            });
        },

        deleteComment(commentId) {
            axios.delete(`complaints/${this.complaint}/comments/${commentId}`, config.AXIOS_DEFAULTS)
                .then((response) => {
                    this.$store.commit('setNotification', [response.message]);
                    this.fetchComments();
                    this.$emit('updated', true)
                })
                .catch(error => {
                    console.error("Error deleting comment:", error);
                });
        },

        isEditing(commentId) {
            return this.editingCommentId === commentId;
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const commentsList = this.$refs.commentsList;
                if (commentsList) {
                    commentsList.scrollTop = commentsList.scrollHeight;
                }
            });
        }
    },
}
</script>
